// Generated by scripts/mdi/import-questionnaires.mjs from MDI "BPC-157 09.17.26" (9b9387e8-1c55-4311-bdb7-76eb8072688f). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiBPC157AnswerField } from './questions';

export const mdiBPC157: FormType<mdiBPC157AnswerField> = {
  name: 'BPC-157',
  validityLength: 25,
  questions: [
    {
      key: 'mdiBPC157_sex',
      next: {
        switch: [
          {
            condition: { 'mdiBPC157_sex.female': true },
            key: 'mdiBPC157_pregnancy'
          },
          {
            condition: { 'mdiBPC157_pregnancy.yes': true },
            key: 'mdiBPC157_wereSorryTreatmentNotMedically'
          },
          {
            condition: { 'mdiBPC157_breastfeeding.yes': true },
            key: 'mdiBPC157_wereSorryTreatmentNotMedically'
          }
        ],
        els: 'mdiBPC157_importantClickAttachedLinkReview'
      }
    },
    {
      key: 'mdiBPC157_pregnancy',
      next: {
        switch: [
          {
            condition: { 'mdiBPC157_sex.female': true },
            key: 'mdiBPC157_breastfeeding'
          },
          {
            condition: { 'mdiBPC157_pregnancy.yes': true },
            key: 'mdiBPC157_wereSorryTreatmentNotMedically'
          },
          {
            condition: { 'mdiBPC157_breastfeeding.yes': true },
            key: 'mdiBPC157_wereSorryTreatmentNotMedically'
          }
        ],
        els: 'mdiBPC157_importantClickAttachedLinkReview'
      }
    },
    {
      key: 'mdiBPC157_breastfeeding',
      next: {
        switch: [
          {
            condition: { 'mdiBPC157_pregnancy.yes': true },
            key: 'mdiBPC157_wereSorryTreatmentNotMedically'
          },
          {
            condition: { 'mdiBPC157_breastfeeding.yes': true },
            key: 'mdiBPC157_wereSorryTreatmentNotMedically'
          }
        ],
        els: 'mdiBPC157_importantClickAttachedLinkReview'
      }
    },
    'mdiBPC157_wereSorryTreatmentNotMedically',
    'mdiBPC157_importantClickAttachedLinkReview',
    'mdiBPC157_reasonInterestedPeptide',
    {
      key: 'mdiBPC157_everUsedPeptideTherapiesPast',
      next: {
        condition: { 'mdiBPC157_everUsedPeptideTherapiesPast.yes': true },
        key: 'mdiBPC157_peptidesUsedPreviously',
        els: 'mdiBPC157_everReactionSideEffectsPeptide'
      }
    },
    'mdiBPC157_peptidesUsedPreviously',
    {
      key: 'mdiBPC157_everReactionSideEffectsPeptide',
      next: {
        condition: { 'mdiBPC157_everReactionSideEffectsPeptide.yes': true },
        key: 'mdiBPC157_reactionSideEffect',
        els: 'mdiBPC157_diagnosedRedFlagMedicalConditions'
      }
    },
    'mdiBPC157_reactionSideEffect',
    'mdiBPC157_diagnosedRedFlagMedicalConditions',
    'mdiBPC157_confirmNotHistoryCancerKidney',
    'mdiBPC157_takeRedFlagMedicationsSubstances',
    'mdiBPC157_allergyBenzylPeroxide',
    'mdiBPC157_lastTimePersonMedicalEvaluation',
    'mdiBPC157_confirmUnderstandContactDoctorQuestions',
    'mdiBPC157_firstMessageDoctor',
    'mdiBPC157_complete'
  ]
};
